import React, { useEffect } from 'react';
import './LegalPages.css';

interface ImprintProps {
  language: 'en' | 'de';
  onClose: () => void;
}

export const Imprint: React.FC<ImprintProps> = ({ language, onClose }) => {
  // Prevent body scroll when legal page is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  const content = {
    de: {
      title: 'Impressum',
      sections: [
        {
          title: 'Angaben gemäß § 5 TMG',
          content: [
            'Dr.-Ing. Simon Wunderlich',
            'Herrenstr. 6',
            '08523 Plauen',
            'Deutschland'
          ]
        },
        {
          title: 'Kontakt',
          content: [
            'E-Mail: sw@simonwunderlich.de'
          ]
        },
        {
          title: 'Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV',
          content: [
            'Dr.-Ing. Simon Wunderlich',
            'Herrenstr. 6',
            '08523 Plauen',
            'Deutschland'
          ]
        },
        {
          title: 'Haftungsausschluss',
          content: [
            'Die Inhalte dieser App wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.',
            'Die App "Zuckerrechner" dient ausschließlich informativen Zwecken. Die bereitgestellten Nährwertdaten basieren auf öffentlich verfügbaren Quellen und können Fehler enthalten.',
            'Die App ersetzt keine professionelle medizinische Beratung. Bei gesundheitlichen Fragen wende Dich an Deinen Arzt oder Diabetesberater.'
          ]
        }
      ],
      backButton: 'Zurück'
    },
    en: {
      title: 'Imprint',
      sections: [
        {
          title: 'Information according to § 5 TMG',
          content: [
            'Dr.-Ing. Simon Wunderlich',
            'Herrenstr. 6',
            '08523 Plauen',
            'Germany'
          ]
        },
        {
          title: 'Contact',
          content: [
            'Email: sw@simonwunderlich.de'
          ]
        },
        {
          title: 'Responsible for content according to § 55 para. 2 RStV',
          content: [
            'Dr.-Ing. Simon Wunderlich',
            'Herrenstr. 6',
            '08523 Plauen',
            'Germany'
          ]
        },
        {
          title: 'Disclaimer',
          content: [
            'The contents of this app have been created with the greatest care. However, we cannot guarantee the accuracy, completeness and timeliness of the content.',
            'The "Zuckerrechner" app serves informational purposes only. The provided nutritional data is based on publicly available sources and may contain errors.',
            'The app does not replace professional medical advice. For health questions, consult your doctor or diabetes counselor.'
          ]
        }
      ],
      backButton: 'Back'
    }
  };

  const { title, sections, backButton } = content[language];

  return (
    <div className="legal-page">
      <div className="legal-header">
        <div className="legal-header-top">
          <div className="legal-app-branding clickable-branding" onClick={onClose}>
            <img src="/logo96.png" alt="Logo" className="legal-logo" />
            <span className="legal-app-name">Zuckerrechner <span className="beta-label">beta</span></span>
          </div>
          <button className="legal-back-button" onClick={onClose}>
            ← {backButton}
          </button>
        </div>
        <h1 className="legal-title">{title}</h1>
      </div>
      
      <div className="legal-content">
        {sections.map((section, index) => (
          <section key={index} className="legal-section">
            <h2 className="legal-section-title">{section.title}</h2>
            {section.title.includes('Angaben gemäß') || section.title.includes('Information according') || section.title.includes('Verantwortlich für') || section.title.includes('Responsible for') ? (
              <div className="legal-paragraph address-block">
                {section.content.map((line, lIndex) => (
                  <div key={lIndex}>{line}</div>
                ))}
              </div>
            ) : (
              section.content.map((paragraph, pIndex) => (
                <p key={pIndex} className="legal-paragraph">
                  {paragraph}
                </p>
              ))
            )}
          </section>
        ))}
      </div>
    </div>
  );
};